<div *ngIf="isMobile">
  <app-project-notes-mobile></app-project-notes-mobile>
</div>

<div *ngIf="!isMobile">
  <div *ngIf="notes" class="container-fluid">
    <div class="form-inline">
      <h5 class="mr-1" i18n>Notes</h5>
      <button class="btn btn-bidit-navigate" (click)="addNote()" i18n>Add Note</button>
    </div>

    <table class="table table-bidit table-striped">
      <thead>
        <tr>
          <th i18n>Note</th>
          <th i18n>Created By</th>
          <th i18n>Date</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="notes.length == 0">
          <td colspan="4" i18n>No notes for this project exist</td>
        </tr>

        <tr *ngFor="let note of notes">
          <td>
            {{note.quoteNote_Text}}
          </td>
          <td>
            {{note.createdBy.firstName}} {{note.createdBy.lastName}}
          </td>
          <td>
            {{note.quoteNote_Created | date: 'M/d/yyyy'}}
          </td>
          <td>
            <a (click)="editNote(note)" class="btn btn-bidit-edit mr-1"></a>
            <a (click)="deleteNote(note)" class="btn btn-bidit-delete"></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
